import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Box, Flex } from 'grid-styled'
import { ISODateFormat, capitalize, currencyParser } from 'alelo-logic/utils'
import Hide from '../../../styles/utilities/Hide'
import InvoiceStatus from '../InvoiceStatus'
import { Content, LinkToInvoice, ListItem, Title, ButtonAlert } from './styles'

import { showModal } from '../../modules/ModalRoot/actions'
import imageContestacao from '../../../static/contestacao.png'
import { CONFIRM_UPDATE } from '../../../constants/ModalTypes'

class InvoiceListItem extends Component {
  currentInvoiceMessage = () => {
    const { actualPlan: { posData: { cutDay } } } = this.props
    this.props.dispatch(
      showModal(CONFIRM_UPDATE, {
        modalTitle: 'Fatura Atual',
        modalDescription: `A sua fatura ainda está aberta e será fechada dia ${ISODateFormat(
          cutDay
        )}. Para consultar suas transações antes do fechamento acesse o menu Extrato.`,
        image: imageContestacao
      })
    )
  }

  render() {
    const {
      dataVencimento,
      formaPagamento,
      planId,
      status,
      valor,
      numero,
      nsu,
      qtdTransacoes,
      downloadTicket,
      exibirTransacoes,
      linkBoleto,
      requestNewBoleto
    } = this.props

    let idMes = `lista_fatura_mes_${numero}`
    let idValorTotal = `lista_fatura_valor_total_${numero}`
    let idVencimento = `lista_fatura_vencimento_${numero}`
    let idStatus = `lista_fatura_status_${numero}`
    return (
      <ListItem>
        <Content>
          <Flex width={1} direction={['column', 'row']}>
            <Box width={[1, 2 / 12]} mr={35} style={{ display: 'flex', alignItems: 'stretch' }}>
              {dataVencimento === null && exibirTransacoes === false ? (
                <ButtonAlert
                  onClick={() => this.currentInvoiceMessage()}
                  style={{ display: 'flex', alignItems: 'center' }}
                >
                  <Title status={status} id={idMes}>
                    {capitalize(ISODateFormat(dataVencimento, 'MMMM')) || 'Atual'}
                  </Title>
                </ButtonAlert>
              ) : (
                <LinkToInvoice
                  to={`/minha-veloe/${planId}/fatura/${numero}/${qtdTransacoes}`}
                  style={{ display: 'flex', alignItems: 'center' }}
                >
                  <Title status={status} id={idMes}>
                    {capitalize(ISODateFormat(dataVencimento, 'MMMM')) || 'Atual'}
                  </Title>
                </LinkToInvoice>
              )}
            </Box>
            <Hide
              at="small"
              width={[1, 3 / 12]}
              style={{ display: 'flex', alignItems: 'stretch', justifyContent: 'flex-end' }}
            >
              {dataVencimento === null && exibirTransacoes === false ? (
                <ButtonAlert
                  onClick={() => this.currentInvoiceMessage()}
                  style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}
                >
                  <Title right status={status} id={idValorTotal}>
                    {currencyParser(valor * -1)}
                  </Title>
                </ButtonAlert>
              ) : (
                <LinkToInvoice
                  to={`/minha-veloe/${planId}/fatura/${numero}/${qtdTransacoes}`}
                  style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}
                >
                  <Title right status={status} id={idValorTotal}>
                    {currencyParser(valor * -1)}
                  </Title>
                </LinkToInvoice>
              )}
            </Hide>
            <Hide at="small" width={[1, 3 / 12]} style={{ display: 'flex', alignItems: 'stretch' }}>
              {dataVencimento === null && exibirTransacoes === false ? (
                <ButtonAlert
                  onClick={() => this.currentInvoiceMessage()}
                  style={{ display: 'flex', alignItems: 'center' }}
                >
                  <Title status={status} id={idVencimento}>
                    {ISODateFormat(dataVencimento) || 'Em aberto'}
                  </Title>
                </ButtonAlert>
              ) : (
                <LinkToInvoice
                  to={`/minha-veloe/${planId}/fatura/${numero}/${qtdTransacoes}`}
                  style={{ display: 'flex', alignItems: 'center' }}
                >
                  <Title status={status} id={idVencimento}>
                    {ISODateFormat(dataVencimento) || 'Em aberto'}
                  </Title>
                </LinkToInvoice>
              )}
            </Hide>
            <Box width={[2, 4 / 12]}>
              <InvoiceStatus
                dataVencimento={dataVencimento}
                status={status}
                method={formaPagamento}
                planId={planId}
                fatura={numero}
                nsu={nsu}
                qtdTransacoes={qtdTransacoes}
                downloadTicket={downloadTicket}
                idElemento={idStatus}
                linkBoleto={linkBoleto}
                requestNewBoleto={requestNewBoleto}
              />
            </Box>
          </Flex>
        </Content>
      </ListItem>
    )
  }
}

const mapStateToProps = ({ reducer }) => ({
  actualPlan:
    reducer.accountPlans.plans.find(plan => plan.accountId === reducer.accountPlans.activePlanId) ||
    {}
})

export default connect(mapStateToProps)(InvoiceListItem)



// WEBPACK FOOTER //
// ./src/app/elements/InvoiceListItem/index.js